import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { useAppDispatch, useAppSelector } from "../../lib/redux/hook";
import { EditIcon } from "../../ui/icons/editIcon";
import { TrashIcon } from "../../ui/icons/trashIcon";
import { SpinnerComponent } from "../../ui/molecules/spinner/index";
import { ConfirmModal } from "../../ui/organisms/confirmModal/index";
import { Dropdown } from "../../ui/organisms/dropDown/index";
import { deleteCustomer, findAllCustomers, findCustomerById, resetCustomerCreateRequest, setCreateCustomerStatus, setCustomerFilterSort, setCustomerFilterSortBy, setCustomerId, setOpenConfirmModal, setSelectedCustomer, setTab } from "./slice";
import { SuccessPopup } from "../../ui/organisms/successPopup";
import { ErrorPopup } from "../../ui/organisms/errorPopup";
import { findAllPayments } from "./payment/slice";
import { SortIcon } from "../../ui/icons/sortIcon";

export function CustomerList() {
    const customerState = useAppSelector(state => state.customer)
    const paymentState = useAppSelector(state => state.payment)
    const dispatch = useAppDispatch()
    const navigate = useNavigate()

    const [isDelete, setIsDelete] = useState<string | undefined>()

    useEffect(() => {
        dispatch(findAllCustomers(customerState.customerFilters))
    }, [customerState.customerFilters.sort, customerState.customerFilters.sortBy])

    useEffect(() => {
        if (customerState.createCustomerStatus === "successfully") {
            dispatch(findAllCustomers(customerState.customerFilters))
            dispatch(resetCustomerCreateRequest())
        }
    }, [customerState.createCustomerStatus])

    useEffect(() => {
        if (customerState.createCustomerStatus === "failed") {
            dispatch(resetCustomerCreateRequest())
        }
    }, [customerState.createCustomerStatus])

    useEffect(() => {
        if (customerState.deleteCustomerStatus === "successfully") {
            dispatch(findAllCustomers(customerState.customerFilters))
        }
    }, [customerState.deleteCustomerStatus])

    useEffect(() => {
        if (customerState.editCustomerStatus === "successfully") {
            dispatch(findAllCustomers(customerState.customerFilters))
        }
    }, [customerState.editCustomerStatus])

    if (customerState.findAllCustomersStatus === "loading" || customerState.createCustomerStatus === "loading" || customerState.deleteCustomerStatus === "loading" || customerState.editCustomerStatus === "loading") {
        return (
            <div className={"flex justify-center items-center flex-grow"}>
                <SpinnerComponent />
            </div>
        )
    }

    return (
        <div className="w-full flex flex-col gap-4 bg-neutral-100 rounded-tr-xl rounded-tl-xl overflow-auto">
            <SuccessPopup message="Cliente creato con successo!" active={customerState.createCustomerStatus === 'successfully'} close={() => dispatch(setCreateCustomerStatus('idle'))} />
            <ErrorPopup message="La creazione del cliente è fallita." active={customerState.createCustomerStatus === 'failed'} close={() => dispatch(setCreateCustomerStatus('idle'))
            } />
            <div>
                <table className="w-full">
                    <thead className="h-[56px] font-semibold text-neutral-500 text-text-xs">
                        <tr>
                            <th className="text-left">
                                <div className="flex py-4 px-2 gap-1">
                                    RAGIONE SOCIALE
                                    <SortIcon onClick={() => {
                                        dispatch(setCustomerFilterSort((customerState.customerFilters.sort === 0 || customerState.customerFilters.sort === -1) ? 1 : -1))
                                        dispatch(setCustomerFilterSortBy('business_name'))
                                    }} size={"20"} color={""} />
                                </div>
                            </th>
                            {
                                customerState.findAllCustomersResponse?.customers.length !== 0 &&
                                <>
                                    <th className="text-left">
                                        <div className="flex py-4 pl-4 gap-1">
                                            NOME
                                            <SortIcon onClick={() => {
                                                dispatch(setCustomerFilterSort((customerState.customerFilters.sort === 0 || customerState.customerFilters.sort === -1) ? 1 : -1))
                                                dispatch(setCustomerFilterSortBy('name'))
                                            }} size={"20"} color={""} />
                                        </div>
                                    </th>
                                    <th className="text-left">
                                        <div className="flex py-4 px-2 gap-1">
                                            COGNOME
                                            <SortIcon onClick={() => {
                                                dispatch(setCustomerFilterSort((customerState.customerFilters.sort === 0 || customerState.customerFilters.sort === -1) ? 1 : -1))
                                                dispatch(setCustomerFilterSortBy('surname'))
                                            }} size={"20"} color={""} />
                                        </div>
                                    </th>
                                    <th className="text-left">
                                        <div className="flex py-4 px-2 gap-1">
                                            EMAIL
                                            <SortIcon onClick={() => {
                                                dispatch(setCustomerFilterSort((customerState.customerFilters.sort === 0 || customerState.customerFilters.sort === -1) ? 1 : -1))
                                                dispatch(setCustomerFilterSortBy('email'))
                                            }} size={"20"} color={""} />
                                        </div>
                                    </th>
                                    <th className="text-left">
                                        <div className="flex py-4 px-2 gap-1">
                                            P.IVA
                                        </div>
                                    </th>
                                    <th className="text-left">
                                        <div className="flex py-4 px-2 gap-1">
                                            TASSO DI MAGGIORAZIONE
                                        </div>
                                    </th>
                                    <th className="text-left">
                                        <div className="flex py-4 px-2 gap-1">
                                            QUOTA MINIMA (PREZZO I.E.)
                                        </div>
                                    </th>
                                    <th className="text-left">
                                        <div className="flex py-4 px-2 gap-1" />
                                    </th>
                                </>
                            }
                        </tr>
                    </thead>
                    <tbody>
                        {
                            customerState.findAllCustomersResponse?.customers.length === 0 ?
                                <tr className="bg-white h-[56px] border-b-[1px] border-b-neutral-100 w-full">
                                    <td className="py-4 px-4 text-text-sm font-medium text-neutral-500">
                                        Nessun cliente
                                    </td>
                                </tr>
                                :
                                customerState.findAllCustomersResponse?.customers.map(item =>
                                    <tr
                                        className="bg-white h-[56px] border-b-[1px] border-b-neutral-100"
                                        key={item.customer_id}
                                    >
                                        <td onClick={() => {
                                            dispatch(setSelectedCustomer(item.id))
                                            navigate('/customer/' + item.id)
                                        }} className="py-4 px-2 text-text-sm font-semibold text-neutral-600 hover:text-neutral-500 cursor-pointer">
                                            {item.business_name.length <= 20 ? item.business_name : item.business_name.substring(0, 20).concat('...')}
                                        </td>
                                        <td onClick={() => {
                                            dispatch(setSelectedCustomer(item.id))
                                            navigate('/customer/' + item.id)
                                        }} className="py-4 px-2 text-text-sm font-semibold text-neutral-600 hover:text-neutral-500 cursor-pointer">{item.name.length <= 20 ? item.name : item.name.substring(0, 20).concat('...')}</td>
                                        <td className="py-4 px-2 text-text-sm font-semibold text-neutral-600">{item.surname.length <= 20 ? item.surname : item.surname.substring(0, 20).concat('...')}</td>
                                        <td className="py-4 px-2 text-text-sm font-semibold text-neutral-600">{item.email.length <= 20 ? item.email : item.email.substring(0, 20).concat('...')}</td>
                                        <td className="py-4 px-2 text-text-sm font-semibold text-neutral-600">{item.vat}</td>
                                        <td className="py-4 px-2 text-text-sm font-semibold text-neutral-600">{item.markup_rate}%</td>
                                        <td className="py-4 px-2 text-text-sm font-semibold text-neutral-600">{item.min_quota}</td>
                                        <td className="w-[40px] cursor-pointer">
                                            <Dropdown items={[
                                                {
                                                    label: 'Modifica',
                                                    icon: <EditIcon color="" size={""} />,
                                                    onClick: () => {
                                                        navigate('/customer/' + item.id.toString())
                                                        dispatch(findCustomerById(item.id))
                                                        dispatch(setTab(1))
                                                    }
                                                },
                                                {
                                                    label: 'Cancella',
                                                    icon: <TrashIcon color="" size={""} />,
                                                    onClick: () => {
                                                        setIsDelete(item.id)
                                                        dispatch(setOpenConfirmModal(true))
                                                    }
                                                }
                                            ]} />
                                        </td>
                                    </tr>
                                )
                        }
                    </tbody>
                </table>
            </div>
            <ConfirmModal
                open={customerState.openConfirmModal}
                handleClose={() => dispatch(setOpenConfirmModal(false))}
                title={"Elimina cliente"}
                description={"Sei sicuro di voler eliminare questo cliente?"}
                labelDeny={"Annulla"}
                labelConfirm={"Elimina"}
                actionConfirm={() => {
                    isDelete && dispatch(deleteCustomer(isDelete))
                    dispatch(setOpenConfirmModal(false))
                }}
            />
        </div>
    )
}